import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  height: 100vh;
  overflow-y: auto;
  width: calc(100vw - 60px);

  @media (min-width: 769px) {
    margin-left: 60px !important;
  }
  @media (max-width: 768px) {
    width: 100vw;
  }
`;

export const Title = styled.h5`
  width: 100%;
  margin: 0.5rem 0 0.2rem 0;
  color: #8e44ad;
  font-weight: 500;
  padding-left: 0.8rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
`;

export const LinhaKey = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 0.8rem;
  border-bottom: 1px solid lightgray;

  > textarea {
    position: relative;
    resize: none;
    width: 80%;
    min-width: 80%;
    max-width: 100%;
    height: 120px;
    padding: 0.5rem;
    border: none;
    border: 1px solid #d9d9d9;
    margin: 2px;
    color: #1a1a1a;
    box-shadow: 400;
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    > textarea {
      width: 95%;
    }
  }
`;

export const LinhaSaveButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.8rem;
  width: 100%;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    background: #8e44ad !important;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 100px;
    border: none;
    padding: 0.5rem 1rem;
    transition: all 0.2s linear;

    &:hover {
      background: #843fa2 !important;
      border-color: none !important;
    }
  }
`;

export const DivDetalheButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-right: 2rem;

  [type='checkbox'] + span:not(.lever) {
    color: #000;
    font-size: 1.2rem;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    background: #8e44ad !important;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 100px;
    border: none;
    padding: 0.5rem 1rem;

    transition: all 0.2s linear;

    &:hover {
      background: #843fa2 !important;
      border-color: none !important;
    }
  }

  @media (max-width: 769px) {
    flex-direction: row;
    justify-content: space-between;
    gap: 5px;
  }
`;

export const ScreenDialog = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  position: fixed;
  left: 0;
  top: 0;
  background-color: rgb(0, 0, 0, 0.45);
  z-index: 999;
`;

export const Input = styled.input`
  border: 1px solid rgba(133, 133, 128, 0.4) !important;
  border-radius: 7px !important;
  padding: 0px 10px !important;
  margin: 0px !important;
  box-sizing: border-box !important;
`;

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;

  @media (max-width: 769px) {
    flex-direction: column;
  }
`;

export const ContainerTitle = styled.div`
  text-align: left;
  width: 100%;
  border-bottom: 1px solid #8e44ad;

  > h3 {
    color: #8e44ad;
    font-size: 1.1rem;
    font-weight: 500;
    margin: 0;
  }
`;

export const DivDetalhe = styled.div`
  position: absolute;
  background: none;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  right: 10px;
  text-align: left;
  line-height: 0.9rem;
  button {
    background: none !important;
    color: #ccc !important;
    border: none !important;

    padding-right: 0 !important;

    :focus {
      box-shadow: none !important;
    }
  }
`;

export const DialogOptions = styled.div`
  position: fixed;
  left: 0;
  top: 0;

  background: rgb(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
  z-index: 999;
`;

export const DialogContent = styled.div`
  z-index: 999;
  display: flex;
  width: 97%;
  flex-direction: column;
  gap: 1.2rem;
  background: #fff;
  padding: 0.6rem;
  border-radius: 2px;

  > h2 {
    font-size: 1.4rem;
    font-weight: 600;
    color: #8e44ad;
    margin: 0;
  }
`;

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

export const DataFilter = styled.div`
  flex: 1;
  font-weight: 700;
  flex-direction: row;
  display: flex;
  top: 9px;
  position: relative;
  font-weight: 700;
  @media (max-width: 768px) {
    margin-bottom: 6px;
  }

  .react-datepicker-wrapper {
    margin: 0px 10px 10px 10px;
    max-width: 150px;
  }
  .react-datepicker__input-container {
    input {
      font-size: 0.9rem !important;
      font-weight: 700 !important;
      border-bottom: 0px !important;
      margin-bottom: 0px !important;
      height: 30px;
    }
  }

  .react-datepicker {
    border: unset;
    box-shadow: -1px 1px 5px 1px rgba(0, 0, 0, 0.1);
    button {
      background-color: #61098a !important;
    }
    z-index: 999 !important;
  }

  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker__day:hover {
    background-color: #bf1f7c4f !important;
  }

  .react-datepicker__day--selected {
    background-color: #bf1f7c !important;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: white;
    color: rgba(0, 0, 0);
  }

  .react-datepicker__header {
    background-color: #61098a;
  }

  .react-datepicker__header div {
    color: white !important;
  }
  .react-datepicker__header {
    border-bottom: unset;
  }

  .react-datepicker__today-button {
    background: #61098a;
    color: white;
    border-top: unset;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .react-datepicker__header {
    color: white;
  }

  .react-datepicker__month--selected {
    background-color: #bf1f7c;
  }

  .react-datepicker__month-text:hover {
    background-color: #bf1f7c4f !important;
  }

  .react-datepicker__month--selected {
    background-color: #bf1f7c !important;
  }

  .react-datepicker__day--in-range {
    background-color: #bf1f7c !important;
  }

  ${(props) =>
    props.loading === 1
      ? css`
          .wait {
            animation: ${rotate} 2s linear infinite;
            display: block;
            color: rgb(189, 32, 123);
            font-size: 1.4rem;
            position: absolute;
            top: 1px;
          }
        `
      : css`
          .wait {
            animation: unset;
            display: none;
            color: rgb(189, 32, 123);
            font-size: 1.4rem;
          }
        `};
`;
